import React from 'react';
import {
  Box,
} from '@mui/material';
import { Form, FormRenderProps } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import ReactFinalFormWrapper, {
  composeValidators, requiredField, validEmail, validZip,
} from '../register/ReactFinalFormWrapper';
import { buildCountryOptions } from '../../utilities/regions';
import { BillingAddress, PartialBy } from '../../redux/types';

const formConfiguration = {
  label: <FormattedMessage id="registration.personalInformationHeading" />,
  formRef: 'billing_form',
  fields: [
    {
      label: <FormattedMessage id="trialSetup.instituteNameColumn" />,
      key: 'name',
      type: 'text',
      validate: requiredField,
    },
    {
      label: <FormattedMessage id="registration.userEmail" />,
      key: 'email',
      type: 'text',
      validate: composeValidators(requiredField, validEmail),
    },
    {
      label: <FormattedMessage id="registration.customClearanceContact" />,
      key: 'contactNumber',
      type: 'text',
      validate: requiredField,
    },
    {
      label: <FormattedMessage id="registration.instituteStreet" />,
      key: 'street',
      type: 'text',
      validate: requiredField,
    },
    {
      label: <FormattedMessage id="registration.instituteHousenumber" />,
      key: 'houseNumber',
      type: 'text',
      validate: requiredField,
    },
    {
      label: <FormattedMessage id="registration.instituteZip" />,
      key: 'postcode',
      type: 'text',
      validate: composeValidators(requiredField, validZip),
    },
    {
      label: <FormattedMessage id="registration.instituteCity" />,
      key: 'city',
      type: 'text',
      validate: requiredField,
    },
    {
      label: <FormattedMessage id="registration.userCountry" />,
      key: 'country',
      type: 'select',
      required: false,
      options: buildCountryOptions('en', true),
      validate: requiredField,
    },
  ],
  requiredMessage: <FormattedMessage id="registration.requiredMessage" />,
};

type Props = {
  submitButtonRef: React.MutableRefObject<HTMLButtonElement |null>;
  onSubmit: (data?: PartialBy<Omit<BillingAddress, 'quipUserId'>, 'id'>) => void
  defaultData?: BillingAddress;
}

const BillingAddressForm: React.FC<Props> = ({
  submitButtonRef,
  onSubmit,
  defaultData,
}: Props) => (
  <Box sx={{ width: '100%' }}>
    <Form
      onSubmit={(values) => {
        if (values) {
          onSubmit(values as PartialBy<BillingAddress, 'id'>);
        }
      }}
      initialValues={defaultData}
      render={({ handleSubmit }: FormRenderProps) => (
        <form onSubmit={handleSubmit}>
          <ReactFinalFormWrapper registrationForm={formConfiguration} />
          <button style={{ display: 'none' }} ref={submitButtonRef} type="submit">submit</button>
        </form>
      )}
    />
  </Box>
);

export default BillingAddressForm;
